export class NewsletterService {
    constructor(submissionEndpoint) {
        this._submissionEndpoint = submissionEndpoint;
    }
    async register(emailAddress) {
        const normalizedEmail = this._normalizeInput(emailAddress);
        const shouldSend = this._isValidEmailAddress(normalizedEmail);
        if (shouldSend) {
            const response = await fetch(this._buildRequestObject(normalizedEmail));
            return response.json();
        }
        throw new Error("Invalid email address");
    }
    _isValidEmailAddress(emailAddress) {
        const validEmailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/, "g");
        const matches = emailAddress.match(validEmailRegex);
        if (matches === null) {
            return false;
        }
        else {
            return true;
        }
    }
    _normalizeInput(originalInput) {
        return originalInput.toLocaleLowerCase().trim();
    }
    _buildRequestObject(emailAddress) {
        // Time out after 10 seconds if we don't already have a response
        const timeoutAbortSignal = AbortSignal.timeout(10000); // milliseconds
        const apiRequest = new Request(this._submissionEndpoint, {
            method: 'POST', // *GET, POST, PUT, DELETE, etc.
            signal: timeoutAbortSignal,
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify({ email: emailAddress }), // body data type must match "Content-Type" header
        });
        return apiRequest;
    }
}
//# sourceMappingURL=newsletter-service.js.map